<template>
  <div
    v-if="
    ['Home','KioskMode','Category','CategoryCategory','DeliveryStart','KioskStart'].includes(this.$route.name) && this.languagesCount > 1"
    :class="['flex-row flex items-center flex-wrap mr-2 justify-end',
    menu.layout == 'frydate' ? 'font-sans' : '' ]"
  >
    <div
      @click="show"
      class="flex items-center bg-primary-100 rounded-xxl p-1 cursor-pointer"
      :style="makeStyles(hasKiosk && languageButtonRadius, showLanguages, headerButtonBackground, languageButtonBorderColor)"
    >
      <img class="w-4 md:w-6 mr-2" :src="currentLanguage.flagSrc" />
      <p class="text-new-primary text-xs md:text-md font-bold pr-2" :style="btnThirdText">
        <span v-if="!hasKiosk">{{ currentLanguage.shortLabel }}</span>
        <span v-else>{{ currentLanguage.fullLabel }}</span>
      </p>
    </div>
    <transition name="slide-fade-reverse">
    <modal
      name="languages"
      width="90%"
      transition="slide-fade-reverse"
      :maxWidth="480"
      height="auto"
      :adaptive="true"
      scrollable
      class="roundedmodal languageTest"
      @closed="hide"
      @before-close="closingModal"
      @before-open="openingModal"
      > 
      <Language />
    </modal>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import lang from "../lang";
import Language from "../views/Language";
//flags
import nether from "../assets/images/flags/nether.png";
import engels from "../assets/images/flags/engels.png";
import france from "../assets/images/flags/france.png"; 
import germany from "../assets/images/flags/germany.png";

export default {
  name:"LanguageModel",
  components: { Language },
  data() {
    return {
      lang: lang,
            languages: [
        {
          code: 'nl',
          flagSrc: nether,
          shortLabel: 'NL',
          fullLabel: 'Nederlands'
        },
        {
          code: 'en',
          flagSrc: engels,
          shortLabel: 'EN',
          fullLabel: 'English'
        },
        {
          code: 'fr',
          flagSrc: france,
          shortLabel: 'FR',
          fullLabel: 'Français'
        },
        {
          code: 'de',
          flagSrc: germany,
          shortLabel: 'DE',
          fullLabel: 'Deutsch'
        }
      ]
    };
  },
  computed: {
    ...mapGetters("Theme", [
      "btnThirdBackground",
      "btnThirdText",
      "showLanguages",
      "languageButtonRadius",
      "languageButtonBorderColor",
      "headerButtonBackground"
    ]),
    ...mapGetters(["language", "languagesCount", "menu", "hasKiosk"]),
    currentLanguage() {
      return this.languages.find(lang => lang.code === this.language);
    }
  },
  watch: {
    menu(){
      // checks if the localstorage language matches the restaurant, if not use the standard menu language
      if (
        localStorage.getItem("language") == this.menu.language ||
        (localStorage.getItem("language") == "nl" && this.menu.hasNL) ||
        (localStorage.getItem("language") == "fr" && this.menu.hasFR) ||
        (localStorage.getItem("language") == "de" && this.menu.hasDE) ||
        (localStorage.getItem("language") == "en" && this.menu.hasEN)
      ) {
        this.$store.commit("changeLanguage", localStorage.getItem("language"));
      } else {
        this.$store.commit("changeLanguage", this.menu.language);
      }
      this.$store.commit("deleteLanguagesCount", 0);
      if (this.menu.hasDE !== false) {
        this.$store.commit("updateLanguagesCount", 1);
      }
      if (this.menu.hasFR !== false) {
        this.$store.commit("updateLanguagesCount", 1);
      }
      if (this.menu.hasNL !== false) {
        this.$store.commit("updateLanguagesCount", 1);
      }
      if (this.menu.hasEN !== false) {
        this.$store.commit("updateLanguagesCount", 1);
      }

    },
  },

  methods: {
    closingModal() {
      if (document.getElementsByClassName("prev")[0]) {
        document.getElementsByClassName("prev")[0].style.display = "flex";
        document.getElementsByClassName("next")[0].style.display = "flex";
      }
    },
    openingModal() {
      if (document.getElementsByClassName("prev")[0]) {
        document.getElementsByClassName("prev")[0].style.display = "none";
        document.getElementsByClassName("next")[0].style.display = "none";
      }
    },
    hide() {
      this.$modal.hide("languages");
    },
    show() {
      this.$modal.show("languages");
    },
  },
};
</script>

<style>
.slide-fade-reverse-enter-active {
  transition: all .3s ease-out;
}
.slide-fade-reverse-leave-active {
  transition: all .3s ease-out;
}
.slide-fade-reverse-enter {
  transform : translateX(100%);
  opacity: 0;
}
.slide-fade-reverse-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style>
